import { Panel } from "@/components/admin/ui";

const inputClass = "mt-1 w-full rounded-xl border border-slate-300 px-3 py-2.5 text-sm dark:border-white/15 dark:bg-white/5 dark:text-white";
const labelClass = "text-xs font-bold uppercase tracking-[0.12em] text-slate-400 dark:text-slate-500";

// Canonical customer-facing identity - a single source other Nova Opsis surfaces
// (quotes, contracts, forms, communications) can consume as they adopt it.
export const CustomerFacingInfoSection = ({ form, onChange }) => (
  <Panel title="Customer-Facing Information" subtitle="How your organization appears to customers in quotes, forms and communications." testId="org-settings-customer-facing">
    <div className="grid gap-4 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <label className={labelClass}>Customer-Facing Business Name</label>
        <input value={form.customer_facing_name || ""} onChange={(e) => onChange({ customer_facing_name: e.target.value })} data-testid="org-settings-customer-facing-name-input" className={inputClass} />
      </div>
      <div>
        <label className={labelClass}>Customer Service Phone</label>
        <input value={form.customer_service_phone || ""} onChange={(e) => onChange({ customer_service_phone: e.target.value })} data-testid="org-settings-customer-service-phone-input" className={inputClass} />
      </div>
      <div>
        <label className={labelClass}>Customer Service Email</label>
        <input type="email" value={form.customer_service_email || ""} onChange={(e) => onChange({ customer_service_email: e.target.value })} data-testid="org-settings-customer-service-email-input" className={inputClass} />
      </div>
      <div className="sm:col-span-2">
        <label className={labelClass}>Customer-Facing Website</label>
        <input value={form.customer_facing_website || ""} onChange={(e) => onChange({ customer_facing_website: e.target.value })} placeholder="https://" data-testid="org-settings-customer-facing-website-input" className={inputClass} />
      </div>
    </div>
  </Panel>
);
